var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('homeNav',{on:{"switchTab":_vm.switchTab}}),_c('imgView'),_c('scienceTabs',{ref:"child"}),_c('backtop'),_c('homeFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }